import type { IUseCase } from 'shared-kernel';
import type { ISessionRepository } from '../../../domain/ports';
import type { RevoqueSessionData } from '../../dto/dtos';

export class RevokeSessionUseCase implements IUseCase<RevoqueSessionData, void> {
  constructor(
    private readonly sessionRepository: ISessionRepository,
  ) {}

  async execute(input: RevoqueSessionData): Promise<void> {
    const response = await this.sessionRepository.revokeSession(input);

    if (!response.succes) {
      throw new Error(response.message || 'Echec de la revocation de la session');
    }
  }
}
